import { render } from "./tabelaPrecoForm.vue?vue&type=template&id=57729f53&scoped=true"
import script from "./tabelaPrecoForm.vue?vue&type=script&lang=js"
export * from "./tabelaPrecoForm.vue?vue&type=script&lang=js"

import "./tabelaPrecoForm.vue?vue&type=style&index=0&id=57729f53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57729f53"]])

export default __exports__